import { render } from "./products-content-page.vue?vue&type=template&id=7a17d104"
import script from "./products-content-page.vue?vue&type=script&lang=js"
export * from "./products-content-page.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__